import PropTypes from 'prop-types';
import { MenuOutlined } from '@ant-design/icons';
import style from './Collapser.module.scss';

const Collapser = ({ toggleSideMenu }) => {
  // When viewing Sidekiq, no menu will appear.
  // Empty div used for alignment
  if (!toggleSideMenu) return <div />;

  return (
    <MenuOutlined
      className={style.icon}
      data-testid="icon-menu"
      onClick={toggleSideMenu}
    />
  );
};

Collapser.propTypes = {
  toggleSideMenu: PropTypes.func
};

export default Collapser;
